var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var SheetRowPath = /** @class */ (function () {
    function SheetRowPath(path) {
        this.path = path;
        this.segments = [];
        var pathSegments = path.split('_');
        this.sheetRowId = Number(pathSegments[pathSegments.length - 1].split(':')[0]);
        var fullPath = '';
        for (var i = 0; i < pathSegments.length; i++) {
            var pathSegment = pathSegments[i];
            var tagId = void 0;
            var sheetRowId = 0;
            if (fullPath !== '') {
                fullPath += '_';
            }
            fullPath += pathSegment;
            // check if cluster is generated
            if (pathSegment.indexOf(':') !== -1) {
                var pathSegmentSplat = pathSegment.split(':');
                sheetRowId = Number(pathSegmentSplat[0]);
                tagId = Number(pathSegmentSplat[1]);
            }
            else {
                sheetRowId = Number(pathSegment);
            }
            this.segments.push({
                sheetRowId: sheetRowId,
                tagId: tagId,
                fullPath: fullPath,
                pathSegment: pathSegment,
            });
        }
    }
    SheetRowPath.prototype.includes = function (path) {
        var e_1, _a;
        try {
            for (var _b = __values(this.segments), _c = _b.next(); !_c.done; _c = _b.next()) {
                var seg = _c.value;
                if (typeof path === 'string' ? seg.fullPath === path : seg.fullPath === path.path) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    SheetRowPath.prototype.toString = function () {
        return this.path;
    };
    SheetRowPath.prototype.getPath = function () {
        return this.segments.map(function (s) { return s.pathSegment; });
    };
    return SheetRowPath;
}());
export { SheetRowPath };
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        this.children = new Map();
    }
    return TreeNode;
}());
var PathTree = /** @class */ (function () {
    function PathTree() {
        this.root = new TreeNode();
    }
    PathTree.prototype.insert = function (object) {
        var e_2, _a;
        var path = object.getPath();
        var currentNode = this.root;
        try {
            for (var path_1 = __values(path), path_1_1 = path_1.next(); !path_1_1.done; path_1_1 = path_1.next()) {
                var segment = path_1_1.value;
                var next = currentNode.children.get(segment);
                if (!next) {
                    next = new TreeNode();
                    currentNode.children.set(segment, next);
                }
                currentNode = next;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (path_1_1 && !path_1_1.done && (_a = path_1.return)) _a.call(path_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        currentNode.object = object;
    };
    PathTree.prototype.findOne = function (path) {
        var currentNode = this.findNode(path);
        if (currentNode) {
            return currentNode.object;
        }
    };
    PathTree.prototype.findAll = function (path) {
        var e_3, _a;
        var currentNode = this.findNode(path);
        if (!currentNode) {
            return [];
        }
        var out = [];
        try {
            for (var _b = __values(currentNode.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), childNode = _d[1];
                this.collectChildrenInArray(childNode, out);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return out;
    };
    PathTree.prototype.findAllToMap = function (path) {
        var e_4, _a;
        var currentNode = this.findNode(path);
        var out = new Map();
        if (!currentNode) {
            return out;
        }
        try {
            for (var _b = __values(currentNode.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), childNode = _d[1];
                this.collectChildrenInMap(childNode, out);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return out;
    };
    PathTree.prototype.collectChildrenInMap = function (node, children) {
        var e_5, _a;
        if (!node.object) {
            return;
        }
        children.set(node.object.toString(), node.object);
        try {
            for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), childNode = _d[1];
                this.collectChildrenInMap(childNode, children);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    PathTree.prototype.collectChildrenInArray = function (node, children) {
        var e_6, _a;
        if (!node.object) {
            return;
        }
        children.push(node.object);
        try {
            for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), childNode = _d[1];
                this.collectChildrenInArray(childNode, children);
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
    };
    PathTree.prototype.findNode = function (path) {
        var e_7, _a;
        var currentNode = this.root;
        try {
            for (var path_2 = __values(path), path_2_1 = path_2.next(); !path_2_1.done; path_2_1 = path_2.next()) {
                var segment = path_2_1.value;
                var next = currentNode.children.get(segment);
                if (!next) {
                    return;
                }
                currentNode = next;
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (path_2_1 && !path_2_1.done && (_a = path_2.return)) _a.call(path_2);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return currentNode;
    };
    return PathTree;
}());
export { PathTree };
